import React, { useState } from "react";
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Stack,
  FormHelperText,
} from "@mui/material";
import Swal from "sweetalert2";
import { forgotPassword } from "../Services/AuthService";
import { useNavigate } from "react-router-dom";

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [loading, setLoading] = useState(false);
  const [userIdError, setUserIdError] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setUserIdError(false);
  
    if (userId.trim() === "") {
      setUserIdError(true);
      return;
    }
  
    setLoading(true);
    try {
      const response = await forgotPassword({ userId });
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.message,
      });
      setUserId("");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("orgId");
      localStorage.removeItem("orgName");
      localStorage.clear();
      sessionStorage.clear(); 
      navigate("/", { replace: true });
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Failed to send email",
      });
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <Box
      minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgcolor="#f0f2f5"
      px={2}
    >
      <Paper elevation={3} sx={{ maxWidth: 400, width: "100%", p: 4 }}>
        <Typography variant="h5" textAlign="center" fontWeight="bold" mb={2}>
          Forgot Password
        </Typography>

        <Typography
          variant="body2"
          textAlign="center"
          color="text.secondary"
          mb={3}
        >
          Enter your User ID. We'll send email for password reset link if user exists.
        </Typography>

        <form onSubmit={handleSubmit}>
          <Stack spacing={2}>
            <TextField
              label="User ID"
              variant="outlined"
              fullWidth
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              error={userIdError}
            />
            {userIdError && (
              <FormHelperText error>Please enter your User ID*</FormHelperText>
            )}

            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={loading}
            >
              {loading ? "Sending..." : "Get Password"}
            </Button>
          </Stack>
        </form>
      </Paper>
    </Box>
  );
};

export default ForgotPassword;
